import { useTheme } from '@mui/material';

import { Page, PageHeader } from '@/components';
import { KeyboardShortcutsPanel } from '@/components/KeyboardPanel';

const KeyboardShortcutPage = () => {
  const theme = useTheme();

  return (
    <Page>
      <PageHeader title="Keyboard Shortcuts" />
      <div
        className="flex gap-4 p-4 mt-4 rounded-md"
        style={{ backgroundColor: theme.palette.background.paper }}
      >
        <KeyboardShortcutsPanel />
      </div>
    </Page>
  );
};

export default KeyboardShortcutPage;
